var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8e4b5bc42b8031d76c703dd413c30069e5783e86"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cube-front@rac"]={id:"8e4b5bc42b8031d76c703dd413c30069e5783e86"};
      